module.exports = __webpack_public_path__ + "static/media/page-break.be07fc9e.svg";